module.exports = __webpack_public_path__ + "static/logo-on-white-text-c6f51f19e069c10f7e78c90566d32531.svg";